// Figma: node 18034:1379 — Account Status / Total Stake Units / Active Stake Units.
// LOGIC PORTED verbatim from LC2's DetailsContent.js (Portfolio view, openItem ===
// 'portfolio' branch): LC2's third metric there is "Total units" — the unfiltered sum of
// every community's total_units__c, with the same "Processing" fallback (shown while the
// account is Demoing/Onboarding and that sum is still 0) as its "Total Stake units" sibling.
// LC2 never had a metric literally called "Active Stake Units" (flagged as a gap in an
// earlier pass, which duplicated "Total Stake Units" into both cards as a placeholder) —
// per product, this card should carry LC2's exact "Total units" computation under the new
// Figma label, not a fabricated "active" definition.
import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {Box, Stack, Typography} from '@mui/material';

import {getCommunities} from '../../app/store/reducers/entities';
import {getDashboardAccount} from '../../app/store/reducers/dashboard';
import {ACTIVE_PROPERTY_STATUSES} from '../../commons/constants/communityConstants';
import {formatNumber} from '../../commons/constants/stylingConstants';
import {tokens} from '../../themes/ThemeCustomization';
import Badge from './components/Badge';

const StatCard = ({label, children, borderLeft}) => (
    <Stack
        sx={{
            flex: 1,
            minWidth: '166px',
            p: 2,
            gap: 0.5,
            backgroundColor: tokens.color.white,
            borderLeft: borderLeft ? `1px solid ${tokens.color.neutral200}` : 'none'
        }}
    >
        <Typography variant="body2" color="text.secondary">
            {label}
        </Typography>
        {children}
    </Stack>
);

const StatCards = () => {
    const communities = useSelector(getCommunities);
    const dashboardAccount = useSelector(getDashboardAccount);

    const isProcessing = dashboardAccount?.account_status__c && ['Demoing', 'Onboarding'].includes(dashboardAccount.account_status__c);

    const totalUnits = useMemo(() => communities.reduce((acc, c) => acc + (c.total_units__c || 0), 0), [communities]);

    const totalStakeUnits = useMemo(
        () =>
            communities
                .filter((c) => ACTIVE_PROPERTY_STATUSES.includes(c.property_status__c))
                .reduce((acc, c) => acc + (c.total_units__c || 0), 0),
        [communities]
    );

    return (
        <Box sx={{display: 'flex', border: `1px solid ${tokens.color.neutral200}`, borderRadius: '6px', overflow: 'hidden'}}>
            <StatCard label="Account Status">
                <Box>
                    <Badge label={dashboardAccount?.account_status__c || 'Onboarding'} variant="info" />
                </Box>
            </StatCard>
            <StatCard label="Total Stake Units" borderLeft>
                <Typography variant="h6" fontWeight={600}>
                    {isProcessing && totalStakeUnits === 0 ? 'Processing' : formatNumber(totalStakeUnits)}
                </Typography>
            </StatCard>
            <StatCard label="Active Stake Units" borderLeft>
                <Typography variant="h6" fontWeight={600}>
                    {isProcessing && totalUnits === 0 ? 'Processing' : formatNumber(totalUnits)}
                </Typography>
            </StatCard>
        </Box>
    );
};

export default StatCards;
